module.exports = __webpack_public_path__ + "img/up.ed107a0a.png";